import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="bg-orange-500 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl font-bold text-white mb-4">联系我们</h1>
            <p className="text-xl text-orange-100">
              我们随时为您提供帮助和支持
            </p>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">客服热线</h3>
                    <p className="text-gray-600">010-84855667</p>
                    <p className="text-sm text-gray-500">工作时间：周一至周日 9:00-21:00</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">邮箱地址</h3>
                    <p className="text-gray-600">service@redfocus.cn</p>
                    <p className="text-sm text-gray-500">我们会在24小时内回复您的邮件</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">公司地址</h3>
                    <p className="text-gray-600">北京市西城区北三环中路29号华龙大厦B座24层</p>
                    <p className="text-sm text-gray-500">欢迎预约参观我们的办公室</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 mb-1">营业时间</h3>
                    <p className="text-gray-600">24小时在线服务</p>
                    <p className="text-sm text-gray-500">随时为您提供优质的购物体验</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-center text-gray-800 mb-12">常见问题</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">如何保证商品质量？</h3>
                <p className="text-gray-600 mb-4">
                  我们与知名品牌厂商直接合作，所有商品均为正品行货，并提供完善的质量保障和售后服务。
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">配送范围和时间？</h3>
                <p className="text-gray-600 mb-4">
                  目前覆盖全国主要城市，一般情况下1-3天内送达，部分地区支持当日达或次日达服务。
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">如何申请退换货？</h3>
                <p className="text-gray-600 mb-4">
                  收到商品后如有质量问题，请在7天内联系客服，我们承诺7天无理由退换货，确保您的购物无忧。
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">是否提供技术支持？</h3>
                <p className="text-gray-600 mb-4">
                  我们为办公设备、摄影器材、电子产品等提供专业的技术支持和使用指导，确保您能充分发挥产品性能。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
